export const BUILD_ID = process.env.REACT_APP_BUILD_ID || "dev";
const PUBLIC_URL = process.env.PUBLIC_URL || "";

function isAbsoluteUrl(url) {
  return /^https?:\/\//i.test(url);
}

function withPublicUrl(path) {
  if (!path || isAbsoluteUrl(path)) return path;
  let normalized = path;
  if (normalized.startsWith("/")) {
    normalized = normalized.replace(/^\/(claro|lp)\//, "/");
  }
  if (!PUBLIC_URL) {
    return normalized;
  }
  if (normalized.startsWith(PUBLIC_URL + "/")) {
    return normalized;
  }
  if (normalized.startsWith("/")) {
    return PUBLIC_URL + normalized;
  }
  return PUBLIC_URL + "/" + normalized;
}

export function versionedUrl(path) {
  if (!path) return path;
  const urlWithBase = withPublicUrl(path);
  const hasQuery = urlWithBase.includes("?");
  return `${urlWithBase}${hasQuery ? "&" : "?"}v=${BUILD_ID}`;
}


